/**
 * @license lucide-react v0.570.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [
  ["path", { d: "M20 11v6", key: "d77pzp" }],
  ["path", { d: "M20 13h2", key: "16rner" }],
  ["path", { d: "M3 21v-2a4 4 0 0 1 4-4h6a4 4 0 0 1 2.072.578", key: "1yxgtw" }],
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }],
  ["circle", { cx: "20", cy: "19", r: "2", key: "1obnsp" }]
];
const UserKey = createLucideIcon("user-key", __iconNode);

export { __iconNode, UserKey as default };
//# sourceMappingURL=user-key.js.map
